import React, { useState } from 'react';
import { FaBirthdayCake, FaCheck, FaCheckCircle, FaEnvelope, FaFileAlt, FaGraduationCap, FaIndustry, FaPen, FaPhoneAlt, FaRegBuilding, FaRegFileAlt, FaRegUser, FaShieldAlt, FaUser } from 'react-icons/fa';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import axios from 'axios';


const Form3f1 = () => {

    const [formStep, setFormStep] = useState(1);
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        chiefPromoter: '',
        designation: '',
        yearOfIncorporation: '',
        areasOfOperation: '',
        attendAwards: '',
        willingToSupplement: '',
        willingToPresent: '',
        writeUp: '',
        otherInfo: '',
        legalCompliance: {
            statutoryApprovals: false,
            noPFTaxLiabilities: false,
            noOffences: false,
            notNPA: false,
            noChildEmployment: false,
        },
        applicantName: '',
        applicantDesignation: '',
        applicantEmail: '',
        applicantPhone: '',
        signature: '',
    });

    const [signatureFile, setSignatureFile] = useState(null);

    const handleSignatureChange = (e) => {
        setSignatureFile(e.target.files[0]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData({
            ...formData,
            legalCompliance: {
                ...formData.legalCompliance,
                [name]: checked ? 1 : 0,
            },
        });
    };

    const [form1_id, setForm1Id] = useState('');
    const [email, setForm1Email] = useState('');

    const handleSubmit1 = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('address', formData.address);
        formDataToSend.append('phone', formData.phone);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('chiefPromoter', formData.chiefPromoter);
        formDataToSend.append('designation', formData.designation);
        formDataToSend.append('yearOfIncorporation', formData.yearOfIncorporation);
        formDataToSend.append('areasOfOperation', formData.areasOfOperation);
        formDataToSend.append('attendAwards', formData.attendAwards);
        formDataToSend.append('willingToSupplement', formData.willingToSupplement);
        formDataToSend.append('willingToPresent', formData.willingToPresent);
        formDataToSend.append('writeUp', formData.writeUp);
        formDataToSend.append('otherInfo', formData.otherInfo);

        formDataToSend.append('statutoryApprovals', formData.legalCompliance.statutoryApprovals ? '1' : '0');
        formDataToSend.append('noPFTaxLiabilities', formData.legalCompliance.noPFTaxLiabilities ? '1' : '0');
        formDataToSend.append('noOffences', formData.legalCompliance.noOffences ? '1' : '0');
        formDataToSend.append('notNPA', formData.legalCompliance.notNPA ? '1' : '0');
        formDataToSend.append('noChildEmployment', formData.legalCompliance.noChildEmployment ? '1' : '0');

        formDataToSend.append('applicantName', formData.applicantName);
        formDataToSend.append('applicantDesignation', formData.applicantDesignation);
        formDataToSend.append('applicantEmail', formData.applicantEmail);
        formDataToSend.append('applicantPhone', formData.applicantPhone);

        if (signatureFile) {
            formDataToSend.append('signature', signatureFile);
        }

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/api-form1/submit', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(response.data);
            setForm1Id(response.data.form1_id);
            setForm1Email(response.data.email);
            setFormStep(2);
            alert('Form submitted successfully');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form. Please try again.');
        }
    };


    //  ---------> form 2

    const [snapshotOfOrganisation, setSnapshotOfOrganisation] = useState('');
    const [vision, setVision] = useState('');
    const [achievementsOfOrganisation, setAchievementsOfOrganisation] = useState('');
    const [contributionToExchequer, setContributionToExchequer] = useState('');
    const [sizeOfOrganisationBelow10, setSizeOfOrganisationBelow10] = useState('');
    const [sizeOfOrganisation10to20, setSizeOfOrganisation10to20] = useState('');
    const [sizeOfOrganisation20to50, setSizeOfOrganisation20to50] = useState('');
    const [sizeOfOrganisationAbove50, setSizeOfOrganisationAbove50] = useState('');
    const [ownershipSoleProprietor, setOwnershipSoleProprietor] = useState(false);
    const [ownershipPartnershipFirm, setOwnershipPartnershipFirm] = useState(false);
    const [ownershipPrivateLimitedCompany, setOwnershipPrivateLimitedCompany] = useState(false);
    const [ownershipLimitedCompany, setOwnershipLimitedCompany] = useState(false);
    const [ownershipCooperativeSociety, setOwnershipCooperativeSociety] = useState(false);
    const [sectorPrivate, setSectorPrivate] = useState(false);
    const [sectorPublic, setSectorPublic] = useState(false);
    const [sectorGovernmentCentral, setSectorGovernmentCentral] = useState(false);
    const [sectorGovernmentState, setSectorGovernmentState] = useState(false);
    const [sectorOthers, setSectorOthers] = useState(false);
    const [noOfEmployeesLessThan20, setNoOfEmployeesLessThan20] = useState('');
    const [noOfEmployees20to50, setNoOfEmployees20to50] = useState('');
    const [noOfEmployees50to100, setNoOfEmployees50to100] = useState('');
    const [noOfEmployeesAbove100, setNoOfEmployeesAbove100] = useState('');
    const [financialResults2021_22, setFinancialResults2021_22] = useState('');
    const [financialResults2022_23, setFinancialResults2022_23] = useState('');
    const [financialResults2023_24, setFinancialResults2023_24] = useState('');

    const [main_products_services_description1, setMainProductsServicesDescription1] = useState('');
    const [main_products_services_capacity1, setMainProductsServicesCapacity1] = useState('');
    const [main_products_services_description2, setMainProductsServicesDescription2] = useState('');
    const [main_products_services_capacity2, setMainProductsServicesCapacity2] = useState('');
    const [main_products_services_description3, setMainProductsServicesDescription3] = useState('');
    const [main_products_services_capacity3, setMainProductsServicesCapacity3] = useState('');
    const [major_facilities_land_area, setMajorFacilitiesLandArea] = useState('');
    const [major_facilities_factory_built_up_area, setMajorFacilitiesFactoryBuiltUpArea] = useState('');
    const [major_facilities_major_equipment, setMajorFacilitiesMajorEquipment] = useState('');
    const [major_facilities_specialized_facility, setMajorFacilitiesSpecializedFacility] = useState('');
    const [major_facilities_services, setMajorFacilitiesServices] = useState('');
    const [technology_adopted_traditional, setTechnologyAdoptedTraditional] = useState(false);
    const [technology_adopted_indigenous, setTechnologyAdoptedIndigenous] = useState(false);
    const [technology_adopted_in_house_r_d, setTechnologyAdoptedInHouseRD] = useState(false);
    const [technology_adopted_foreign_technology, setTechnologyAdoptedForeignTechnology] = useState(false);
    const [technology_adopted_franchise, setTechnologyAdoptedFranchise] = useState(false);
    const [technology_adopted_comment, setTechnologyAdoptedComment] = useState('');
    const [quality_compliance_iso, setQualityComplianceIso] = useState(false);
    const [quality_compliance_bis, setQualityComplianceBis] = useState(false);
    const [quality_compliance_gmp_who_fda_haccp, setQualityComplianceGmpWhoFdaHaccp] = useState(false);
    const [quality_compliance_other, setQualityComplianceOther] = useState(false);
    const [quality_compliance_comment, setQualityComplianceComment] = useState('');
    const [management_functions_human_resources_department, setManagementFunctionsHumanResourcesDepartment] = useState(false);
    const [management_functions_finance_accounts, setManagementFunctionsFinanceAccounts] = useState(false);
    const [management_functions_marketing_business_development, setManagementFunctionsMarketingBusinessDevelopment] = useState(false);
    const [management_functions_r_d, setManagementFunctionsRD] = useState(false);
    const [management_functions_internal_audit, setManagementFunctionsInternalAudit] = useState(false);
    const [management_functions_quality_assurance, setManagementFunctionsQualityAssurance] = useState(false);
    const [management_functions_other, setManagementFunctionsOther] = useState(false);
    const [management_functions_comment, setManagementFunctionsComment] = useState('');
    const [level_of_it_intervention_use_of_erp, setLevelOfITInterventionUseOfERP] = useState(false);
    const [level_of_it_intervention_customized_software, setLevelOfITInterventionCustomizedSoftware] = useState(false);
    const [level_of_it_intervention_general_office_solutions, setLevelOfITInterventionGeneralOfficeSolutions] = useState(false);
    const [level_of_it_intervention_no_it_facility, setLevelOfITInterventionNoITFacility] = useState(false);
    const [level_of_it_intervention_comment, setLevelOfITInterventionComment] = useState('');
    const [award_recognition_yes, setAwardRecognitionYes] = useState(false);
    const [award_recognition_no, setAwardRecognitionNo] = useState(false);
    const [award_recognition_comment, setAwardRecognitionComment] = useState('');

    const [strategic_plan_for_future_yes, setStrategicPlanForFutureYes] = useState(false);
    const [strategic_plan_for_future_no, setStrategicPlanForFutureNo] = useState(false);
    const [strategic_plan_for_future_comment, setStrategicPlanForFutureComment] = useState('');

    const [about_product_service_description, setAboutProductServiceDescription] = useState('');
    const [about_product_service_capacity, setAboutProductServiceCapacity] = useState('');
    const [about_product_service_features, setAboutProductServiceFeatures] = useState('');
    const [about_product_service_uniqueness, setAboutProductServiceUniqueness] = useState('');
    const [about_product_service_market, setAboutProductServiceMarket] = useState('');
    const [about_product_service_export_content_in_turnover, setAboutProductServiceExportContentInTurnover] = useState('');

    const [about_chief_promoter_educational_qualification, setAboutChiefPromoterEducationalQualification] = useState('');
    const [about_chief_promoter_experience_in_line, setAboutChiefPromoterExperienceInLine] = useState('');
    const [about_chief_promoter_first_generation_entrepreneur, setAboutChiefPromoterFirstGenerationEntrepreneur] = useState('');
    const [about_chief_promoter_contribution_to_organisation, setAboutChiefPromoterContributionToOrganisation] = useState('');
    const [about_chief_promoter_relevant_details, setAboutChiefPromoterRelevantDetails] = useState('');

    const [signatureUrl, setSignatureUrl] = useState('');
    const [name, setName] = useState('');
    const [designation, setDesignation] = useState('');

    // Handle form submission
    const handleSubmit2 = async (e) => {
        e.preventDefault();

        const formData = {
            snapshot_of_organisation: snapshotOfOrganisation,
            vision: vision,
            achievements_of_organisation: achievementsOfOrganisation,
            contribution_to_exchequer: contributionToExchequer,
            size_of_organisation_below_10: sizeOfOrganisationBelow10,
            size_of_organisation_10_20: sizeOfOrganisation10to20,
            size_of_organisation_20_50: sizeOfOrganisation20to50,
            size_of_organisation_above_50: sizeOfOrganisationAbove50,
            ownership_sole_proprietor: ownershipSoleProprietor,
            ownership_partnership_firm: ownershipPartnershipFirm,
            ownership_private_limited_company: ownershipPrivateLimitedCompany,
            ownership_limited_company: ownershipLimitedCompany,
            ownership_cooperative_society: ownershipCooperativeSociety,
            sector_private: sectorPrivate,
            sector_public: sectorPublic,
            sector_government_central: sectorGovernmentCentral,
            sector_government_state: sectorGovernmentState,
            sector_others: sectorOthers,
            no_of_employees_less_than_20: noOfEmployeesLessThan20,
            no_of_employees_20_50: noOfEmployees20to50,
            no_of_employees_50_100: noOfEmployees50to100,
            no_of_employees_above_100: noOfEmployeesAbove100,
            financial_results_2021_22: financialResults2021_22,
            financial_results_2022_23: financialResults2022_23,
            financial_results_2023_24: financialResults2023_24,

            main_products_services_description1,
            main_products_services_capacity1,
            main_products_services_description2,
            main_products_services_capacity2,
            main_products_services_description3,
            main_products_services_capacity3,
            major_facilities_land_area,
            major_facilities_factory_built_up_area,
            major_facilities_major_equipment,
            major_facilities_specialized_facility,
            major_facilities_services,
            technology_adopted_traditional,
            technology_adopted_indigenous,
            technology_adopted_in_house_r_d,
            technology_adopted_foreign_technology,
            technology_adopted_franchise,
            technology_adopted_comment,
            quality_compliance_iso,
            quality_compliance_bis,
            quality_compliance_gmp_who_fda_haccp,
            quality_compliance_other,
            quality_compliance_comment,
            management_functions_human_resources_department,
            management_functions_finance_accounts,
            management_functions_r_d,
            management_functions_internal_audit,
            management_functions_quality_assurance,
            management_functions_other,
            management_functions_marketing_business_development,
            management_functions_comment,
            level_of_it_intervention_use_of_erp,
            level_of_it_intervention_customized_software,
            level_of_it_intervention_general_office_solutions,
            level_of_it_intervention_no_it_facility,
            level_of_it_intervention_comment,
            award_recognition_yes,
            award_recognition_no,
            award_recognition_comment,
            strategic_plan_for_future_yes,
            strategic_plan_for_future_no,
            strategic_plan_for_future_comment,
            about_product_service_description,
            about_product_service_capacity,
            about_product_service_features,
            about_product_service_uniqueness,
            about_product_service_market,
            about_product_service_export_content_in_turnover,
            about_chief_promoter_educational_qualification,
            about_chief_promoter_experience_in_line,
            about_chief_promoter_first_generation_entrepreneur,
            about_chief_promoter_contribution_to_organisation,
            about_chief_promoter_relevant_details,

            signature_url: signatureUrl,
            name,
            designation,
            form1_id: form1_id,
        };

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/submit-nomination', formData);
            alert('Data submitted successfully');
            setFormStep(3);
            console.log('respose Data', response);
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert('Error submitting form');
        }
    };

    // form 3--------------------------->


    const [nameo, setNameo] = useState('');
    const [designationo, setDesignationo] = useState('');
    const [age, setAge] = useState('');
    const [experienceTotal, setExperienceTotal] = useState('');
    const [experienceSameLine, setExperienceSameLine] = useState('');
    const [experienceSameOrg, setExperienceSameOrg] = useState('');
    const [isChiefPromoter, setIsChiefPromoter] = useState(false);
    const [isFirstGenNominee, setIsFirstGenNominee] = useState(false);
    const [familyBusiness, setFamilyBusiness] = useState('');
    const [familyIndustry, setFamilyIndustry] = useState('');
    const [familyAgriculture, setFamilyAgriculture] = useState('');
    const [familyService, setFamilyService] = useState('');
    const [familyOther, setFamilyOther] = useState('');
    const [familyComment, setFamilyComment] = useState('');
    const [productTraditional, setProductTraditional] = useState('');
    const [productExisting, setProductExisting] = useState('');
    const [productInnovative, setProductInnovative] = useState('');
    const [productImportSubstitute, setProductImportSubstitute] = useState('');
    const [productComment, setProductComment] = useState('');
    const [sourceIndigenous, setSourceIndigenous] = useState('');
    const [sourceOwnRd, setSourceOwnRd] = useState('');
    const [sourceImported, setSourceImported] = useState('');
    const [sourceComment, setSourceComment] = useState('');
    const [investmentStart, setInvestmentStart] = useState('');
    const [termLoanStart, setTermLoanStart] = useState('');
    const [turnoverStart, setTurnoverStart] = useState('');
    const [pbtStart, setPbtStart] = useState('');
    const [manpowerStart, setManpowerStart] = useState('');
    const [exportsStart, setExportsStart] = useState('');
    const [investmentEnd, setInvestmentEnd] = useState('');
    const [termLoanEnd, setTermLoanEnd] = useState('');
    const [turnoverEnd, setTurnoverEnd] = useState('');
    const [pbtEnd, setPbtEnd] = useState('');
    const [manpowerEnd, setManpowerEnd] = useState('');
    const [exportsEnd, setExportsEnd] = useState('');
    const [orientationIso, setOrientationIso] = useState(false);
    const [orientationHaccp, setOrientationHaccp] = useState(false);
    const [orientationWhoGmpFda, setOrientationWhoGmpFda] = useState(false);
    const [orientationOther, setOrientationOther] = useState(false);
    const [orientationComment, setOrientationComment] = useState('');
    const [contributionNominee, setContributionNominee] = useState('');
    const [contributionNomineeComment, setContributionNomineeComment] = useState('');
    const [contributionPerformanceComment, setContributionPerformanceComment] = useState('');
    const [eligibleForAwardComment, setEligibleForAwardComment] = useState('');
    const [date, setDate] = useState('');
    const [signatureUrlo, setSignatureUrlo] = useState('');
    const [qualifications, setQualifications] = useState([
        { discipline: 'Technical', pg: '', graduate: '', other: '' },
        { discipline: 'Financial', pg: '', graduate: '', other: '' },
        { discipline: 'Management', pg: '', graduate: '', other: '' },
        { discipline: 'Professional', pg: '', graduate: '', other: '' },
        { discipline: 'Other, to specify', pg: '', graduate: '', other: '' }
    ]);
    const [financialIndicators, setFinancialIndicators] = useState([
        { attribute: 'Turnover', start: '', year1: '', year2: '', year3: '' },
        { attribute: 'PAT', start: '', year1: '', year2: '', year3: '' },
        { attribute: 'DER', start: '', year1: '', year2: '', year3: '' },
        { attribute: 'Net Profit/sales', start: '', year1: '', year2: '', year3: '' },
        { attribute: 'Current ratio', start: '', year1: '', year2: '', year3: '' },
        { attribute: 'Net worth', start: '', year1: '', year2: '', year3: '' },
        { attribute: 'ROI', start: '', year1: '', year2: '', year3: '' },
        { attribute: 'Revenue per employee', start: '', year1: '', year2: '', year3: '' }
    ]);
    const [comment, setComment] = useState('');
    const [nameo1, setNameo1] = useState('');

    const handleContributionChange = (event) => {
        setContributionNominee(event.target.value);
    };

    const handleQualificationChange = (index, field, value) => {
        const updatedQualifications = [...qualifications];
        updatedQualifications[index][field] = value;
        setQualifications(updatedQualifications);
    };

    const handleFinancialIndicatorChange = (index, field, value) => {
        const updatedIndicators = [...financialIndicators];
        updatedIndicators[index][field] = value;
        setFinancialIndicators(updatedIndicators);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSignatureUrlo(file); // Store file in state
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', nameo);
        formData.append('designation', designationo);
        formData.append('age', age);
        formData.append('experience_total', experienceTotal);
        formData.append('experience_same_line', experienceSameLine);
        formData.append('experience_same_org', experienceSameOrg);
        formData.append('is_chief_promoter', isChiefPromoter);
        formData.append('is_first_gen_nominee', isFirstGenNominee);
        formData.append('family_business', familyBusiness);
        formData.append('family_industry', familyIndustry);
        formData.append('family_agriculture', familyAgriculture);
        formData.append('family_service', familyService);
        formData.append('family_other', familyOther);
        formData.append('family_comment', familyComment);
        formData.append('product_traditional', productTraditional);
        formData.append('product_existing', productExisting);
        formData.append('product_innovative', productInnovative);
        formData.append('product_import_substitute', productImportSubstitute);
        formData.append('product_comment', productComment);
        formData.append('source_indigenous', sourceIndigenous);
        formData.append('source_own_rd', sourceOwnRd);
        formData.append('source_imported', sourceImported);
        formData.append('source_comment', sourceComment);
        formData.append('investment_start', investmentStart);
        formData.append('term_loan_start', termLoanStart);
        formData.append('turnover_start', turnoverStart);
        formData.append('pbt_start', pbtStart);
        formData.append('manpower_start', manpowerStart);
        formData.append('exports_start', exportsStart);
        formData.append('investment_end', investmentEnd);
        formData.append('term_loan_end', termLoanEnd);
        formData.append('turnover_end', turnoverEnd);
        formData.append('pbt_end', pbtEnd);
        formData.append('manpower_end', manpowerEnd);
        formData.append('exports_end', exportsEnd);
        formData.append('orientation_iso', orientationIso);
        formData.append('orientation_haccp', orientationHaccp);
        formData.append('orientation_who_gmp_fda', orientationWhoGmpFda);
        formData.append('orientation_other', orientationOther);
        formData.append('orientation_comment', orientationComment);
        formData.append('contribution_nominee', contributionNominee);
        formData.append('contribution_nominee_comment', contributionNomineeComment);
        formData.append('contribution_performance_comment', contributionPerformanceComment);
        formData.append('eligible_for_award_comment', eligibleForAwardComment);
        formData.append('date', date);

        formData.append('signature_url', signatureUrlo);  

        formData.append('qualifications', JSON.stringify(qualifications)); 
        formData.append('financial_indicators', JSON.stringify(financialIndicators));
        formData.append('name1', nameo1);
        formData.append('comment', comment);

        formData.append('form1_id', form1_id);
        formData.append('email', email);



        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/submit-pharma-leaderr', formData);
            if (response.status === 200 || response.status === 201) {
                alert('Data submitted successfully!');
                window.location.reload();
            } else {
                alert('Submission failed. Please try again.');
            }
            console.log(response);
        } catch (error) {
            const errorMessage = error.response?.data?.error || 'An error occurred while submitting data.';
            alert(`Error: ${errorMessage}`);
            console.log(errorMessage);
        }
    };


    return (
        <>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '200px', width: '100%' }} />

            <div className='mt-4' style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {[1, 2, 3].map((stepNumber) => (
                    <div
                        key={stepNumber} style={{ width: '60px', height: '30px', borderRadius: '10%', backgroundColor: formStep === stepNumber ? '#007bff' : '#ccc', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', cursor: formStep >= stepNumber ? 'pointer' : 'not-allowed', margin: '0 5px', opacity: formStep >= stepNumber ? 1 : 0.5, }}
                        onClick={() => { if (formStep >= stepNumber) { setFormStep(stepNumber); } }}>
                        {stepNumber}
                    </div>
                ))}
            </div>

            {formStep === 1 && (
                <div className='container'>
                    <h3 style={{ textAlign: 'center', marginBottom: '20px', textTransform: 'uppercase' }}>Declaration Form for Nominations</h3>
                    <form >
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name:</label>
                                <input type="text" name="name" placeholder="Enter Name" value={formData.name} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegBuilding /> Address:</label>
                                <input type="text" name="address" placeholder="Enter Address" value={formData.address} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone:</label>
                                <input type="text" name="phone" placeholder="Enter Phone" value={formData.phone} maxLength={10} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email:</label>
                                <input type="email" name="email" placeholder="Enter Email" value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPen /> Chief Promoter Name:</label>
                                <input type="text" name="chiefPromoter" placeholder="Enter Chief Promoter Name" value={formData.chiefPromoter} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation:</label>
                                <input type="text" name="designation" placeholder="Enter Designation" value={formData.designation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Year of Incorporation:</label>
                                <input type="text" name="yearOfIncorporation" value={formData.yearOfIncorporation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Areas of Operation:</label>
                                <input type="text" name="areasOfOperation" value={formData.areasOfOperation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> If selected, will you attend to the awards function to accept the award:</label>
                                <select name="attendAwards" value={formData.attendAwards} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to supplement any further information?</label>
                                <select name="willingToSupplement" value={formData.willingToSupplement} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to make a presentation before the jury?</label>
                                <select name="willingToPresent" value={formData.willingToPresent} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Write a brief 200-word write-up on why you consider yourself suitable for this Award:</label>
                            <textarea name="writeUp" value={formData.writeUp} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" required />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Any other relevant information in support of the proposal:</label>
                            <textarea name="otherInfo" value={formData.otherInfo} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaShieldAlt /> Legal & Statutory compliance:</label>
                            <div style={{ border: '2px solid #000', padding: '15px', borderRadius: '5px', backgroundColor: '#f8f9fa' }}>
                                <label>
                                    <input type="checkbox" name="statutoryApprovals" checked={formData.legalCompliance.statutoryApprovals} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Has all Statutory approvals
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noPFTaxLiabilities" checked={formData.legalCompliance.noPFTaxLiabilities} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No PF/Tax liabilities
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noOffences" checked={formData.legalCompliance.noOffences} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not involved in any Civil/Criminal/Economic offences
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="notNPA" checked={formData.legalCompliance.notNPA} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not an NPA with Banks/FI
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noChildEmployment" checked={formData.legalCompliance.noChildEmployment} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No Child employment
                                </label>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name of Applicant:</label>
                                <input type="text" name="applicantName" value={formData.applicantName} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation (CEO/MD/Chief Promoter):</label>
                                <input type="text" name="applicantDesignation" value={formData.applicantDesignation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email ID:</label>
                                <input type="email" name="applicantEmail" value={formData.applicantEmail} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone/Mobile:</label>
                                <input type="text" name="applicantPhone" value={formData.applicantPhone} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Signature of Applicant and Company seal:</label>
                            <input type="file" name="signature" accept="image/*" onChange={handleSignatureChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit1} className="btn btn-primary w-100">Submit</button>
                        </div>
                    </form>
                </div>
            )}

            {formStep === 2 && (
                <div className="container">
                    <form>
                        <h4 className='mt-2 mb-2 text-center'>FORM - 2</h4>
                        <p className='mb-0'>A. About the Organisation: (Write up in brief)</p>
                        <div className="mb-3">
                            <label htmlFor="organizationSnapshot" className="form-label">i. A snapshot of the Organisation, chief promoter, the key activities, challenges faced, competition, exports etc.</label>
                            <textarea value={snapshotOfOrganisation} onChange={(e) => setSnapshotOfOrganisation(e.target.value)} className="form-control" id="organizationSnapshot" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section ii */}
                        <div className="mb-3">
                            <label htmlFor="visionMission" className="form-label">ii. Vision, mission and policy of organization</label>
                            <textarea value={vision} onChange={(e) => setVision(e.target.value)} className="form-control" id="visionMission" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iii */}
                        <div className="mb-3">
                            <label htmlFor="achievements" className="form-label">iii. Important achievements of Organisation in the past few years</label>
                            <textarea value={achievementsOfOrganisation} onChange={(e) => setAchievementsOfOrganisation(e.target.value)} className="form-control" id="achievements" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iv */}
                        <div className="mb-3">
                            <label htmlFor="contribution" className="form-label">iv. Contribution to exchequer, society, CSR etc.</label>
                            <textarea value={contributionToExchequer} onChange={(e) => setContributionToExchequer(e.target.value)} className="form-control" id="contribution" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Size of Organisation */}
                        <h5>1. Size of Organisation: (investment in plant & machinery) in Rs Cr</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Below 10</td>
                                    <td><input type="radio" id="below10" name="size" value="below10" onChange={() => setSizeOfOrganisationBelow10('Below 10')} /></td>
                                </tr>
                                <tr>
                                    <td>B. 10 - 20</td>
                                    <td> <input type="radio" id="10to20" name="size" value="10to20" onChange={() => setSizeOfOrganisation10to20('10-20')} /></td>
                                </tr>
                                <tr>
                                    <td>C. 20 - 50</td>
                                    <td><input type="radio" id="20to50" name="size" value="20to50" onChange={() => setSizeOfOrganisation20to50('20-50')} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 50</td>
                                    <td> <input type="radio" id="above50" name="size" value="above50" onChange={() => setSizeOfOrganisationAbove50('Above 50')} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Ownership */}
                        <h5>2. Ownership (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Sole Proprietor</td>
                                    <td> <input type="checkbox" id="soleProprietor" onChange={() => setOwnershipSoleProprietor(!ownershipSoleProprietor)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Partnership Firm</td>
                                    <td> <input type="checkbox" id="partnershipFirm" onChange={() => setOwnershipPartnershipFirm(!ownershipPartnershipFirm)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Private limited Company</td>
                                    <td> <input type="checkbox" id="privateLimitedCompany" onChange={() => setOwnershipPrivateLimitedCompany(!ownershipPrivateLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Limited Company</td>
                                    <td> <input type="checkbox" id="limitedCompany" onChange={() => setOwnershipLimitedCompany(!ownershipLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Cooperative Society</td>
                                    <td> <input type="checkbox" id="cooperativeSociety" onChange={() => setOwnershipCooperativeSociety(!ownershipCooperativeSociety)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Sector */}
                        <h5>3. Sector (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Private</td>
                                    <td>  <input type="checkbox" id="private" onChange={() => setSectorPrivate(!sectorPrivate)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Public</td>
                                    <td> <input type="checkbox" id="public" onChange={() => setSectorPublic(!sectorPublic)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Government - Central</td>
                                    <td> <input type="checkbox" id="governmentCentral" onChange={() => setSectorGovernmentCentral(!sectorGovernmentCentral)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Government - State</td>
                                    <td> <input type="checkbox" id="governmentState" onChange={() => setSectorGovernmentState(!sectorGovernmentState)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Others</td>
                                    <td>  <input type="checkbox" id="others" onChange={() => setSectorOthers(!sectorOthers)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* No of Employees */}
                        <h5>4. No of Employees (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Less than 20</td>
                                    <td> <input type="checkbox" id="lessThan20" onChange={() => setNoOfEmployeesLessThan20(!noOfEmployeesLessThan20)} /></td>
                                </tr>
                                <tr>
                                    <td>B. 20 - 50</td>
                                    <td> <input type="checkbox" id="20to50Employees" onChange={() => setNoOfEmployees20to50(!noOfEmployees20to50)} /></td>
                                </tr>
                                <tr>
                                    <td>C. 50 - 100</td>
                                    <td> <input type="checkbox" id="50to100Employees" onChange={() => setNoOfEmployees50to100(!noOfEmployees50to100)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 100</td>
                                    <td> <input type="checkbox" id="above100Employees" onChange={() => setNoOfEmployeesAbove100(!noOfEmployeesAbove100)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Financial results for last 3 years */}
                        <h5>5. Financial results for last 3 years (As per Annual reports) (In Rs Cr)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Year</th>
                                    <th>Turnover</th>
                                    <th>Net Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>2021-22</td>
                                    <td>0-10</td>
                                    <td>   <input type="text" className="form-control" value={financialResults2021_22} onChange={(e) => setFinancialResults2021_22(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>2022-23</td>
                                    <td>10-50</td>
                                    <td> <input type="text" className="form-control" value={financialResults2022_23} onChange={(e) => setFinancialResults2022_23(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>2023-24</td>
                                    <td>50-100 & above</td>
                                    <td> <input type="text" className="form-control" value={financialResults2023_24} onChange={(e) => setFinancialResults2023_24(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Main Products/Services */}
                        <h5>6. Main Products/Services (Mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Capacity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description1} onChange={(e) => setMainProductsServicesDescription1(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity1} onChange={(e) => setMainProductsServicesCapacity1(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description2} onChange={(e) => setMainProductsServicesDescription2(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity2} onChange={(e) => setMainProductsServicesCapacity2(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description3} onChange={(e) => setMainProductsServicesDescription3(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity3} onChange={(e) => setMainProductsServicesCapacity3(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>7. Major facilities (mention details) (Fill relevant details based on type of your company)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Facility</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a</td>
                                    <td>Land area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_land_area} onChange={(e) => setMajorFacilitiesLandArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>b</td>
                                    <td>Factory built up area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_factory_built_up_area} onChange={(e) => setMajorFacilitiesFactoryBuiltUpArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>c</td>
                                    <td>Major Equipment</td>
                                    <td><input type="text" className="form-control" value={major_facilities_major_equipment} onChange={(e) => setMajorFacilitiesMajorEquipment(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>d</td>
                                    <td>Specialized Facility</td>
                                    <td><input type="text" className="form-control" value={major_facilities_specialized_facility} onChange={(e) => setMajorFacilitiesSpecializedFacility(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>e</td>
                                    <td>Services</td>
                                    <td><input type="text" className="form-control" value={major_facilities_services} onChange={(e) => setMajorFacilitiesServices(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>8. Technology adopted (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Traditional</td>
                                    <td><input type="checkbox" checked={technology_adopted_traditional} onChange={(e) => setTechnologyAdoptedTraditional(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Indigenous</td>
                                    <td><input type="checkbox" checked={technology_adopted_indigenous} onChange={(e) => setTechnologyAdoptedIndigenous(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. In house R & D</td>
                                    <td><input type="checkbox" checked={technology_adopted_in_house_r_d} onChange={(e) => setTechnologyAdoptedInHouseRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Foreign Technology</td>
                                    <td><input type="checkbox" checked={technology_adopted_foreign_technology} onChange={(e) => setTechnologyAdoptedForeignTechnology(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Franchise</td>
                                    <td><input type="checkbox" checked={technology_adopted_franchise} onChange={(e) => setTechnologyAdoptedFranchise(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={technology_adopted_comment} onChange={(e) => setTechnologyAdoptedComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />


                        {/* Quality Compliance */}
                        <h5>9. Quality Compliance (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. ISO</td>
                                    <td><input type="checkbox" checked={quality_compliance_iso} onChange={(e) => setQualityComplianceIso(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. BIS</td>
                                    <td><input type="checkbox" checked={quality_compliance_bis} onChange={(e) => setQualityComplianceBis(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. GMP/WHO/FDA/HACCP</td>
                                    <td><input type="checkbox" checked={quality_compliance_gmp_who_fda_haccp} onChange={(e) => setQualityComplianceGmpWhoFdaHaccp(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Any other, to mention</td>
                                    <td><input type="checkbox" checked={quality_compliance_other} onChange={(e) => setQualityComplianceOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={quality_compliance_comment} onChange={(e) => setQualityComplianceComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>10. Management Functions – Has (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Human Resources Department</td>
                                    <td><input type="checkbox" checked={management_functions_human_resources_department} onChange={(e) => setManagementFunctionsHumanResourcesDepartment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Finance & Accounts</td>
                                    <td><input type="checkbox" checked={management_functions_finance_accounts} onChange={(e) => setManagementFunctionsFinanceAccounts(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. Marketing/ Business Development</td>
                                    <td><input type="checkbox" checked={management_functions_marketing_business_development} onChange={(e) => setManagementFunctionsMarketingBusinessDevelopment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. R & D</td>
                                    <td><input type="checkbox" checked={management_functions_r_d} onChange={(e) => setManagementFunctionsRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Internal Audit</td>
                                    <td><input type="checkbox" checked={management_functions_internal_audit} onChange={(e) => setManagementFunctionsInternalAudit(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>f. Quality Assurance</td>
                                    <td><input type="checkbox" checked={management_functions_quality_assurance} onChange={(e) => setManagementFunctionsQualityAssurance(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>g. Any other, please specify</td>
                                    <td><input type="checkbox" checked={management_functions_other} onChange={(e) => setManagementFunctionsOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={management_functions_comment} onChange={(e) => setManagementFunctionsComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>12. Level of IT intervention (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Use of ERP</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_use_of_erp} onChange={(e) => setLevelOfITInterventionUseOfERP(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Customized software</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_customized_software} onChange={(e) => setLevelOfITInterventionCustomizedSoftware(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. General office solutions</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_general_office_solutions} onChange={(e) => setLevelOfITInterventionGeneralOfficeSolutions(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. No IT facility</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_no_it_facility} onChange={(e) => setLevelOfITInterventionNoITFacility(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={level_of_it_intervention_comment} onChange={(e) => setLevelOfITInterventionComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        {/* In receipt of any Award */}
                        <h5>13. In receipt of any Award/recognition of repute</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="award" checked={award_recognition_yes} onChange={() => setAwardRecognitionYes(true)} /> YES
                                <input type="radio" name="award" checked={award_recognition_no} onChange={() => setAwardRecognitionNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={award_recognition_comment} onChange={(e) => setAwardRecognitionComment(e.target.value)} placeholder="If yes, to mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Strategic Plan */}
                        <h5>14. Does the Organization have a Strategic Plan for future growth</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_yes} onChange={() => setStrategicPlanForFutureYes(true)} /> YES
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_no} onChange={() => setStrategicPlanForFutureNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={strategic_plan_for_future_comment} onChange={(e) => setStrategicPlanForFutureComment(e.target.value)} placeholder="If yes, mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* About Product/Service */}
                        <h3>A. About Product/ Service:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Description of product / service</td>
                                    <td><input type="text" className="form-control" value={about_product_service_description} onChange={(e) => setAboutProductServiceDescription(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Capacity</td>
                                    <td><input type="text" className="form-control" value={about_product_service_capacity} onChange={(e) => setAboutProductServiceCapacity(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Features of product</td>
                                    <td><input type="text" className="form-control" value={about_product_service_features} onChange={(e) => setAboutProductServiceFeatures(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Uniqueness, if any</td>
                                    <td><input type="text" className="form-control" value={about_product_service_uniqueness} onChange={(e) => setAboutProductServiceUniqueness(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Market</td>
                                    <td><input type="text" className="form-control" value={about_product_service_market} onChange={(e) => setAboutProductServiceMarket(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Export content in Turnover</td>
                                    <td><input type="text" className="form-control" value={about_product_service_export_content_in_turnover} onChange={(e) => setAboutProductServiceExportContentInTurnover(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* About Chief Promoter */}
                        <h3>B. About Chief Promoter:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Educational qualification</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_educational_qualification} onChange={(e) => setAboutChiefPromoterEducationalQualification(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Experience in line</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_experience_in_line} onChange={(e) => setAboutChiefPromoterExperienceInLine(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Are you first generation entrepreneur?</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_first_generation_entrepreneur} onChange={(e) => setAboutChiefPromoterFirstGenerationEntrepreneur(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Contribution to the Organization</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_contribution_to_organisation} onChange={(e) => setAboutChiefPromoterContributionToOrganisation(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Any relevant details, to specify</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_relevant_details} onChange={(e) => setAboutChiefPromoterRelevantDetails(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="mb-3">
                            <label className="form-label">Signature:</label>
                            <input value={signatureUrl} onChange={(e) => setSignatureUrl(e.target.value)} type="file" className="form-control" placeholder="Signature" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Name:</label>
                            <input value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Name" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Designation:</label>
                            <input value={designation} onChange={(e) => setDesignation(e.target.value)} type="text" className="form-control" placeholder="Designation" style={{ border: '2px solid #000' }} />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit2} className="btn btn-primary w-100">Submit</button>
                        </div>

                        <p><strong>(To be signed by CEO/MD of Organization)</strong></p>

                    </form>
                </div>
            )}

            {formStep === 3 && (
                <div className="container">
                    <h3 className='text-center'>PHARMA LEADER OF THE YEAR</h3>
                    <form>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label"> <FaUser /> 1. Name</label>
                            <input type="text" className="form-control" value={nameo} onChange={(e) => setNameo(e.target.value)} id="name" style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">  Designation</label>
                            <input type="text" className="form-control" value={designationo} onChange={(e) => setDesignationo(e.target.value)} id="name" style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="age" className="form-label"> <FaBirthdayCake />  2. Age</label>
                            <input value={age} onChange={(e) => setAge(e.target.value)} type="number" className="form-control" id="age" style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label"> <FaGraduationCap /> 3. Qualification (mention details)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000', }} >
                                <thead>
                                    <tr>
                                        <th>S NO</th>
                                        <th>Discipline</th>
                                        <th>PG</th>
                                        <th>Graduate</th>
                                        <th>Other, to specify</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {qualifications.map((qualification, index) => (
                                        <tr key={index}>
                                            <td>{String.fromCharCode(65 + index)}</td>
                                            <td>{qualification.discipline}</td>
                                            <td><input type="text" className="form-control" value={qualification.pg} onChange={(e) => handleQualificationChange(index, 'pg', e.target.value)} /></td>
                                            <td><input type="text" className="form-control" value={qualification.graduate} onChange={(e) => handleQualificationChange(index, 'graduate', e.target.value)} /></td>
                                            <td><input type="text" className="form-control" value={qualification.other} onChange={(e) => handleQualificationChange(index, 'other', e.target.value)} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaIndustry />4. Experience (mention details)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000', }} >
                                <thead>
                                    <tr>
                                        <th>Total (in Years)</th>
                                        <th>In same line</th>
                                        <th>In same Organisation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="number" className="form-control" value={experienceTotal} onChange={(e) => setExperienceTotal(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={experienceSameLine} onChange={(e) => setExperienceSameLine(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={experienceSameOrg} onChange={(e) => setExperienceSameOrg(e.target.value)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"> <FaCheck /> 5. Is nominee Chief Promoter</label>
                            <select className="form-select" style={{ border: '2px solid #000', }} value={isChiefPromoter} onChange={(e) => setIsChiefPromoter(e.target.value)}>
                                <option value="">Select</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"> <FaCheck /> 6. Is nominee a first-generation entrepreneur</label>
                            <select className="form-select" style={{ border: '2px solid #000', }} value={isFirstGenNominee} onChange={(e) => setIsFirstGenNominee(e.target.value)}>
                                <option value="">Select</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaFileAlt /> 7. Family background (tick appropriately)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Business</th>
                                        <th>Industry</th>
                                        <th>Agriculture</th>
                                        <th>Service</th>
                                        <th>Other, to specify</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="checkbox" checked={familyBusiness} onChange={() => setFamilyBusiness(!familyBusiness)} /></td>
                                        <td><input type="checkbox" checked={familyIndustry} onChange={() => setFamilyIndustry(!familyIndustry)} /></td>
                                        <td><input type="checkbox" checked={familyAgriculture} onChange={() => setFamilyAgriculture(!familyAgriculture)} /></td>
                                        <td><input type="checkbox" checked={familyService} onChange={() => setFamilyService(!familyService)} /></td>
                                        <td><input type="checkbox" checked={familyOther} onChange={() => setFamilyOther(!familyOther)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="mb-0">Details in brief:</p>
                            <textarea className="form-control" rows="3" placeholder="Comments" style={{ border: '2px solid #000' }} value={familyComment} onChange={(e) => setFamilyComment(e.target.value)}                         ></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaFileAlt /> 8. About Product / service (tick appropriately)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Traditional</th>
                                        <th>Existing</th>
                                        <th>Innovative</th>
                                        <th>Import substitute</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="checkbox" checked={productTraditional} onChange={() => setProductTraditional(!productTraditional)} /></td>
                                        <td><input type="checkbox" checked={productExisting} onChange={() => setProductExisting(!productExisting)} /></td>
                                        <td><input type="checkbox" checked={productInnovative} onChange={() => setProductInnovative(!productInnovative)} /></td>
                                        <td><input type="checkbox" checked={productImportSubstitute} onChange={() => setProductImportSubstitute(!productImportSubstitute)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="mb-0">Details in brief:</p>
                            <textarea className="form-control" rows="3" placeholder="Comments" style={{ border: '2px solid #000' }} value={productComment} onChange={(e) => setProductComment(e.target.value)}                         ></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">  <FaFileAlt /> 9. Source of technology (tick appropriately)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000', }} >
                                <thead>
                                    <tr>
                                        <th>Indigenous</th>
                                        <th>Own R&D</th>
                                        <th>Imported</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="checkbox" checked={sourceIndigenous} onChange={() => setSourceIndigenous(!sourceIndigenous)} /></td>
                                        <td><input type="checkbox" checked={sourceOwnRd} onChange={() => setSourceOwnRd(!sourceOwnRd)} /></td>
                                        <td><input type="checkbox" checked={sourceImported} onChange={() => setSourceImported(!sourceImported)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className='mb-0'>Details in brief:</p>
                            <textarea className="form-control" rows="3" placeholder="Comments" style={{ border: '2px solid #000' }} value={sourceComment} onChange={(e) => setSourceComment(e.target.value)}             ></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaPen /> 10. Size of unit:</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Attribute</th>
                                        <th>At start (1st year of operation)</th>
                                        <th>At end of the last FY</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Investment in Rs Cr</td>
                                        <td><input type="number" className="form-control" value={investmentStart} onChange={(e) => setInvestmentStart(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={investmentEnd} onChange={(e) => setInvestmentEnd(e.target.value)} /></td>
                                    </tr>
                                    <tr>
                                        <td>Term Loan in Rs Cr</td>
                                        <td><input type="number" className="form-control" value={termLoanStart} onChange={(e) => setTermLoanStart(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={termLoanEnd} onChange={(e) => setTermLoanEnd(e.target.value)} /></td>
                                    </tr>
                                    <tr>
                                        <td>Turnover in Rs Cr</td>
                                        <td><input type="number" className="form-control" value={turnoverStart} onChange={(e) => setTurnoverStart(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={turnoverEnd} onChange={(e) => setTurnoverEnd(e.target.value)} /></td>
                                    </tr>
                                    <tr>
                                        <td>PBT in Rs Cr</td>
                                        <td><input type="number" className="form-control" value={pbtStart} onChange={(e) => setPbtStart(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={pbtEnd} onChange={(e) => setPbtEnd(e.target.value)} /></td>
                                    </tr>
                                    <tr>
                                        <td>Manpower: Skilled + unskilled</td>
                                        <td><input type="number" className="form-control" value={manpowerStart} onChange={(e) => setManpowerStart(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={manpowerEnd} onChange={(e) => setManpowerEnd(e.target.value)} /></td>
                                    </tr>
                                    <tr>
                                        <td>Exports in Rs Cr</td>
                                        <td><input type="number" className="form-control" value={exportsStart} onChange={(e) => setExportsStart(e.target.value)} /></td>
                                        <td><input type="number" className="form-control" value={exportsEnd} onChange={(e) => setExportsEnd(e.target.value)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">11. Financial Indicators (last 3 years)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Attribute/Year</th>
                                        <th>At start - 1st year of operation</th>
                                        <th>Year 1 2022-23</th>
                                        <th>Year 2 2023-24</th>
                                        <th>Year 3 2024-25</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {financialIndicators.map((indicator, index) => (
                                        <tr key={index}>
                                            <td>{indicator.attribute}</td>
                                            <td><input type="number" className="form-control" value={indicator.start} onChange={(e) => handleFinancialIndicatorChange(index, 'start', e.target.value)} /></td>
                                            <td><input type="number" className="form-control" value={indicator.year1} onChange={(e) => handleFinancialIndicatorChange(index, 'year1', e.target.value)} /></td>
                                            <td><input type="number" className="form-control" value={indicator.year2} onChange={(e) => handleFinancialIndicatorChange(index, 'year2', e.target.value)} /></td>
                                            <td><input type="number" className="form-control" value={indicator.year3} onChange={(e) => handleFinancialIndicatorChange(index, 'year3', e.target.value)} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="comments" className="form-label">Comments, if any:</label>
                            <textarea value={comment} onChange={(e) => setComment(e.target.value)} className="form-control" id="comments" rows="3" style={{ border: '2px solid #000', }} ></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">12. Orientation for quality (as applicable)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000', }} >
                                <thead>
                                    <tr>
                                        <th>ISO</th>
                                        <th>HACCP</th>
                                        <th>WHO/GMP/FDA</th>
                                        <th>Any other</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="checkbox" checked={orientationIso} onChange={() => setOrientationIso(!orientationIso)} /></td>
                                        <td><input type="checkbox" checked={orientationHaccp} onChange={() => setOrientationHaccp(!orientationHaccp)} /></td>
                                        <td><input type="checkbox" checked={orientationWhoGmpFda} onChange={() => setOrientationWhoGmpFda(!orientationWhoGmpFda)} /></td>
                                        <td><input type="checkbox" checked={orientationOther} onChange={() => setOrientationOther(!orientationOther)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className='mb-0'>Details in brief:</p>
                            <textarea className="form-control" rows="3" placeholder="Comments" style={{ border: '2px solid #000' }} value={orientationComment} onChange={(e) => setOrientationComment(e.target.value)}       ></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">13. Contribution of nominee for Organisation (a brief on each of the following)</label>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Increase in turnover" checked={contributionNominee === "Increase in turnover"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Increase in turnover</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Increase in productivity" checked={contributionNominee === "Increase in productivity"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Increase in productivity</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Increase in quality/use of quality tools" checked={contributionNominee === "Increase in quality/use of quality tools"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Increase in quality/use of quality tools</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Increase in areas of operation" checked={contributionNominee === "Increase in areas of operation"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Increase in areas of operation</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Introduction of new practices" checked={contributionNominee === "Introduction of new practices"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Introduction of new practices</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Innovations done" checked={contributionNominee === "Innovations done"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Innovations done</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Improvement in HR practices" checked={contributionNominee === "Improvement in HR practices"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Improvement in HR practices</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Any turn around activity" checked={contributionNominee === "Any turn around activity"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Any turn around activity</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Devising strategic plan and implementing" checked={contributionNominee === "Devising strategic plan and implementing"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Devising strategic plan and implementing</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Use of innovative IT practices/MIS" checked={contributionNominee === "Use of innovative IT practices/MIS"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Use of innovative IT practices/MIS</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Development of R & D and use of the technology" checked={contributionNominee === "Development of R & D and use of the technology"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Development of R & D and use of the technology</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Energy conservation" checked={contributionNominee === "Energy conservation"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Energy conservation</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="CSR activities" checked={contributionNominee === "CSR activities"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">CSR activities</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Received any Recognition/ awards of repute" checked={contributionNominee === "Received any Recognition/ awards of repute"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Received any Recognition/ awards of repute</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="contribution" value="Promoted any other units" checked={contributionNominee === "Promoted any other units"} onChange={handleContributionChange} style={{ border: '2px solid #000' }} />
                                <label className="form-check-label">Promoted any other units</label>
                            </div>
                            <textarea value={contributionNomineeComment} onChange={(e) => setContributionNomineeComment(e.target.value)} className="form-control" rows="5" style={{ border: '2px solid #000' }} />
                        </div>


                        {/* Any significant performance contribution */}
                        <div className="mb-3">
                            <label className="form-label">14. Any contribution/performance, which can be said as significant (give details):</label>
                            <textarea value={contributionPerformanceComment} onChange={(e) => setContributionPerformanceComment(e.target.value)} className="form-control" rows="3" style={{ border: '2px solid #000', }} ></textarea>
                        </div>

                        {/* Eligibility for Award */}
                        <div className="mb-3">
                            <label className="form-label">15. Write in 200 words why you consider eligible for this award:</label>
                            <textarea value={eligibleForAwardComment} onChange={(e) => setEligibleForAwardComment(e.target.value)} className="form-control" rows="5" style={{ border: '2px solid #000', }} ></textarea>
                        </div>

                        {/* Signature */}
                        <div className="mb-3">
                            <label className="form-label">Date:</label>
                            <input value={date} onChange={(e) => setDate(e.target.value)} type="date" className="form-control" style={{ border: '2px solid #000', }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Signature of CEO/MD:</label>
                            <input   onChange={handleFileChange} type="file" className="form-control" style={{ border: '2px solid #000', }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Name:</label>
                            <input value={nameo1} onChange={(e) => setNameo1(e.target.value)} type="text" className="form-control" style={{ border: '2px solid #000', }} />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit} className="btn btn-primary w-100">Submit</button>
                        </div>
                    </form>
                </div>
            )}


            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </>
    );
};

export default Form3f1;
